// extracted by mini-css-extract-plugin
module.exports = {"container":"awaiting-time-container__FF_a6","container__unread":"awaiting-time-container__unread__3Mulr"};